var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });



//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/~/core-js/modules/es7.reflect.has-own-metadata.js
// module id = ../../../../core-js/modules/es7.reflect.has-own-metadata.js
// module chunks = 0